import React from 'react';
import { Bug, Lightbulb, AlertTriangle, MessageSquare, CheckCircle2, TrendingUp } from 'lucide-react';

export default function FeedbackStatsBar({ feedback = [] }) {
  var total = feedback.length;
  var active = feedback.filter(function(f) {
    return f.status !== 'resolved' && f.status !== 'closed' && f.status !== 'rejected';
  }).length;
  var resolved = feedback.filter(function(f) {
    return f.status === 'resolved' || f.status === 'closed';
  }).length;
  var bugCount = feedback.filter(function(f) { return f.type === 'bug'; }).length;
  var featureCount = feedback.filter(function(f) { return f.type === 'feature'; }).length;

  var scoresWithValue = feedback.filter(function(f) { return f.priority_score && f.priority_score > 0; });
  var avgPriority = scoresWithValue.length > 0
    ? (scoresWithValue.reduce(function(sum, f) { return sum + f.priority_score; }, 0) / scoresWithValue.length).toFixed(0)
    : '—';

  var stats = [
    { label: 'Total Submissions', value: String(total), icon: MessageSquare, color: 'rgba(99,102,241,1)', bg: 'rgba(99,102,241,0.1)', border: 'rgba(99,102,241,0.2)' },
    { label: 'Active Items', value: String(active), icon: AlertTriangle, color: 'rgba(245,158,11,1)', bg: 'rgba(245,158,11,0.1)', border: 'rgba(245,158,11,0.2)' },
    { label: 'Resolved', value: String(resolved), icon: CheckCircle2, color: 'rgba(34,197,94,1)', bg: 'rgba(34,197,94,0.1)', border: 'rgba(34,197,94,0.2)' },
    { label: 'Bug Reports', value: String(bugCount), icon: Bug, color: 'rgba(239,68,68,1)', bg: 'rgba(239,68,68,0.1)', border: 'rgba(239,68,68,0.2)' },
    { label: 'Feature Requests', value: String(featureCount), icon: Lightbulb, color: 'rgba(20,184,166,1)', bg: 'rgba(20,184,166,0.1)', border: 'rgba(20,184,166,0.2)' },
    { label: 'Avg Priority Score', value: String(avgPriority), icon: TrendingUp, color: 'rgba(168,85,247,1)', bg: 'rgba(168,85,247,0.1)', border: 'rgba(168,85,247,0.2)' },
  ];

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '10px', padding: '12px 20px', background: 'rgba(15,23,42,0.6)', borderBottom: '1px solid rgba(51,65,85,0.6)' }}>
      {stats.map(function(s) {
        return (
          <div key={s.label} style={{ background: s.bg, border: '1px solid ' + s.border, borderRadius: '8px', padding: '10px 12px', display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ background: 'rgba(0,0,0,0.3)', borderRadius: '6px', padding: '6px', flexShrink: 0 }}>
              <s.icon style={{ width: '14px', height: '14px', color: s.color }} />
            </div>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: '18px', fontWeight: 800, color: '#f1f5f9', lineHeight: 1 }}>{s.value}</div>
              <div style={{ fontSize: '9px', color: '#94a3b8', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginTop: '3px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{s.label}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
